import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from "@angular/core";
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from "@angular/forms";

@Component({
	selector: "app-form-card",
	templateUrl: "./form-card.component.html",
	styleUrls: ["./form-card.component.scss"],
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormCardComponent implements OnInit {
	@Input() value!: string;
	@Input() title!: string;
	@Input() description!: string;
	@Input() cntrl!: AbstractControl | null;
	@Input() form!: UntypedFormGroup;
	@Output() focusOut: EventEmitter<any> = new EventEmitter<any>();
	// myInputControl = new FormControl('');

	constructor(private cd: ChangeDetectorRef) {}

	ngOnInit(): void {
		// this.form = this.buildForm();
		this.form.addControl(this.title, new UntypedFormControl());
		// this.myInputControl = new FormControl(this.value || '');
	}

	onCheckBoxClick(control: AbstractControl | null): void {
		control?.patchValue(!control?.value);
		this.cd.detectChanges();
		// this.focusOut.emit(control?.value);/
	}

	onCheckBoxChange(event: any) {
		this.focusOut.emit(event.checked);
	}
}
